import { logger } from '@adornis/base/logging.js';
import { loadMongoData } from '@adornis/baseql/server/data-loader.js';
import { mongo } from '@adornis/buchungsheld-db/server/mongo.js';
import { mailTemplateDefinitions } from '@adornis/mails/db/mail-template-definition.js';
import { BuddyMailTemplate, MailTemplateType } from '../entities/mail-templates.js';

// eslint-disable-next-line max-lines-per-function, complexity
export const ensureDefaultBuddyMailTemplates = async () => {
  // Backfill legacy templates stored without an explicit `scope`. Entity reads
  // apply the `scope ?? 'default'` field default, but getMailTemplateByTypeResolver
  // queries the raw collection and matches `scope` literally, so a missing value
  // makes every send fail with "Mail template not found". Idempotent.
  const collection = mongo().collection(BuddyMailTemplate._collectionName);
  await collection.updateMany(
    { $or: [{ scope: { $exists: false } }, { scope: null }, { scope: '' }] },
    { $set: { scope: 'default' } },
  );

  for (const mailType of Object.values(MailTemplateType)) {
    if (
      [MailTemplateType.FREE_FORM, MailTemplateType.FREE_FORM_MENTEE, MailTemplateType.FREE_FORM_MENTOR].includes(
        mailType,
      )
    )
      continue;

    const definition = mailTemplateDefinitions[mailType];
    if (!definition) throw new Error('No definition found for type: ' + mailType);

    const existingMailTemplate = (await loadMongoData(BuddyMailTemplate, { emailType: mailType })).at(0);
    if (existingMailTemplate) {
      continue;
    }

    const subject = definition.defaultTemplate.subject;
    const content = definition.defaultTemplate.content;
    const name = definition.displayName;
    if (!subject || !content || !name) {
      logger.error({ mailType, subject, content, name }, 'could not create default template');
      throw new Error('cant create default template for type: ' + mailType);
    }

    await new BuddyMailTemplate({ emailType: mailType, name, subject, content, scope: 'default' }).create();
  }
};
